import { render, staticRenderFns } from "./AppointDialog.vue?vue&type=template&id=4c2aefd4&lang=pug"
import script from "./AppointDialog.vue?vue&type=script&lang=js"
export * from "./AppointDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports